// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file chat/chat_update_model.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { Message as Message$1 } from '../message/message_model_pb';
import { file_message_message_model } from '../message/message_model_pb';
import type { ChatEvent } from './chat_event_model_pb';
import { file_chat_chat_event_model } from './chat_event_model_pb';

/**
 * Describes the file chat/chat_update_model.proto.
 */
export const file_chat_chat_update_model: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChxjaGF0L2NoYXRfdXBkYXRlX21vZGVsLnByb3RvEhRjb20uZ2VtLmJmZi5jb250cmFjdCKWBQoKQ2hhdFVwZGF0ZRIyCgljaGF0U3RhdGUYASABKAsyHy5jb20uZ2VtLmJmZi5jb250cmFjdC5DaGF0U3RhdGUSGwoTdW5yZWFkTWVzc2FnZXNDb3VudBgCIAEoAxIgChN0aHJlYWRNZXNzYWdlc0NvdW50GAMgASgDSACIAQESDgoGc2VlblRzGAQgASgDEhgKC2xhc3RFdmVudFRzGAUgASgDSAGIAQESGgoNbGFzdE1lc3NhZ2VUcxgGIAEoA0gCiAEBEh4KEXByZXZpb3VzTWVzc2FnZVRzGAcgASgDSAOIAQESHAoPcHJldmlvdXNFdmVudFRzGAggASgDSASIAQESGwoOb3Bwb25lbnRTZWVuVHMYCSABKANIBYgBARI3CgtsYXN0TWVzc2FnZRgKIAEoCzIdLmNvbS5nZW0uYmZmLmNvbnRyYWN0Lk1lc3NhZ2VIBogBARI3CglsYXN0RXZlbnQYCyABKAsyHy5jb20uZ2VtLmJmZi5jb250cmFjdC5DaGF0RXZlbnRIB4gBARIfChd1bnJlYWRVc2VyTWVudGlvbnNDb3VudBgMIAEoAxIeChFsYXN0VXNlck1lbnRpb25UcxgNIAEoA0gIiAEBEhYKDmNsZWFySGlzdG9yeVRzGA4gASgDQhYKFF90aHJlYWRNZXNzYWdlc0NvdW50Qg4KDF9sYXN0RXZlbnRUc0IQCg5fbGFzdE1lc3NhZ2VUc0IUChJfcHJldmlvdXNNZXNzYWdlVHNCEgoQX3ByZXZpb3VzRXZlbnRUc0IRCg9fb3Bwb25lbnRTZWVuVHNCDgoMX2xhc3RNZXNzYWdlQgwKCl9sYXN0RXZlbnRCFAoSX2xhc3RVc2VyTWVudGlvblRzIi4KCUNoYXRTdGF0ZRIOCgZjaGF0SWQYASABKAMSEQoJdXBkYXRlZFRzGAIgASgDQhgKFGNvbS5nZW0uYmZmLmNvbnRyYWN0UAFiBnByb3RvMw',
    [file_message_message_model, file_chat_chat_event_model]
  );

/**
 * @generated from message com.gem.bff.contract.ChatUpdate
 */
export type ChatUpdate = Message<'com.gem.bff.contract.ChatUpdate'> & {
  /**
   * @generated from field: com.gem.bff.contract.ChatState chatState = 1;
   */
  chatState?: ChatState;

  /**
   * @generated from field: int64 unreadMessagesCount = 2;
   */
  unreadMessagesCount: bigint;

  /**
   * @generated from field: optional int64 threadMessagesCount = 3;
   */
  threadMessagesCount?: bigint;

  /**
   * @generated from field: int64 seenTs = 4;
   */
  seenTs: bigint;

  /**
   * @generated from field: optional int64 lastEventTs = 5;
   */
  lastEventTs?: bigint;

  /**
   * @generated from field: optional int64 lastMessageTs = 6;
   */
  lastMessageTs?: bigint;

  /**
   * @generated from field: optional int64 previousMessageTs = 7;
   */
  previousMessageTs?: bigint;

  /**
   * @generated from field: optional int64 previousEventTs = 8;
   */
  previousEventTs?: bigint;

  /**
   * @generated from field: optional int64 opponentSeenTs = 9;
   */
  opponentSeenTs?: bigint;

  /**
   * @generated from field: optional com.gem.bff.contract.Message lastMessage = 10;
   */
  lastMessage?: Message$1;

  /**
   * @generated from field: optional com.gem.bff.contract.ChatEvent lastEvent = 11;
   */
  lastEvent?: ChatEvent;

  /**
   * @generated from field: int64 unreadUserMentionsCount = 12;
   */
  unreadUserMentionsCount: bigint;

  /**
   * @generated from field: optional int64 lastUserMentionTs = 13;
   */
  lastUserMentionTs?: bigint;

  /**
   * @generated from field: int64 clearHistoryTs = 14;
   */
  clearHistoryTs: bigint;
};

/**
 * Describes the message com.gem.bff.contract.ChatUpdate.
 * Use `create(ChatUpdateSchema)` to create a new message.
 */
export const ChatUpdateSchema: GenMessage<ChatUpdate> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_update_model, 0);

/**
 * @generated from message com.gem.bff.contract.ChatState
 */
export type ChatState = Message<'com.gem.bff.contract.ChatState'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: int64 updatedTs = 2;
   */
  updatedTs: bigint;
};

/**
 * Describes the message com.gem.bff.contract.ChatState.
 * Use `create(ChatStateSchema)` to create a new message.
 */
export const ChatStateSchema: GenMessage<ChatState> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_update_model, 1);
